import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { AddCommentComponent } from '../../../../../modals/add-comment/add-comment.component';
import { HcaMemberService } from '../../../../../../shared/_services/hca-member.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-members-comments',
  templateUrl: './members-comments.component.html',
  styleUrls: ['./members-comments.component.scss']
})
export class MembersCommentsComponent implements OnInit {
  totalCount: number;
  p: number = 0;
  size: number = 10;
  commentsList: any[];
  memberId: any;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private modalService: BsModalService,
    private hcaMemberService: HcaMemberService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "member-edit") {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
                let status = +this.statusModal.content.srcObject.status;
                this.activateOrDeactivate(this.statusModal.content.srcObject.id, status);
              } else {
                this.getCommentsList();
              }
            } else {
              this.getCommentsList();
            }
          }
        }
      })
  }

  activateOrDeactivate(commentId, statusId) {
    console.log(`change status for ${commentId} to ${statusId == 0 ? 'Deactivate' : 'Activate'}`);
    this.hcaMemberService.activateOrDeactivateComment(commentId, statusId).subscribe(res => {
      this.getCommentsList();
    }, err => {
      console.error('Error while updating promotion status: ', err.message);
    });
  }


  openStatusModal(id?, status?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: "Delete Comment",
      message: "Are you sure you want to delete this comment?",
      status,
      id,
      action1: "Delete",
      action2: "Cancel",
      action: '',
      style: "inactive",
    }
  }

  openModalAddComment() {
    this.statusModal = this.modalService.show(AddCommentComponent, { class: 'add-comment-modal' });
    if (this.memberId) {
      this.statusModal.content.memberId = this.memberId;
    }
  }

  getCommentsList(pageNum?) {
    this.p = pageNum ? pageNum : this.p;
    this.hcaMemberService.getCommentsByMemberId(this.p > 0 ? this.p - 1 : this.p, this.memberId).subscribe(res => {
      if (res.error == 0) {
        // this.commentsList = res.responseObj;
        this.commentsList = res.responseObj && res.responseObj.results && res.responseObj.results.length ? res.responseObj.results : [];
        this.totalCount = res.responseObj && res.responseObj.totalRecords ? res.responseObj.totalRecords : 0;
      }
    }, err => {
      console.error('Error while getting list of comments with member id: ', err.message);
    })
  }

  ngOnInit() {
    this.memberId = this.hcaMemberService.getMemberId;
    this.getCommentsList();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/smartAgents/members-management/members-comments/members-comments.component.ts